import Vue from "vue";

import reference from "@/components/controls/sheet/reference.vue";
import selectUsers from "@/components/controls/sheet/selectUsers.vue";
import sheetSelectModal from "@/views/menu/sheet/sheetSelectModal.vue";
import headerDropdown from "./common/headerDropdown.vue";

const componentMap = {
    reference,
    selectUsers,
    sheetSelectModal,
    headerDropdown
};

Object.keys(componentMap).forEach(key => {
    Vue.component(key, componentMap[key]);
});



// WEBPACK FOOTER //
// ./src/components/index.js